import { render, staticRenderFns } from "./CatastropheClosings.vue?vue&type=template&id=ec5f28ec&scoped=true"
import script from "./CatastropheClosings.vue?vue&type=script&lang=js"
export * from "./CatastropheClosings.vue?vue&type=script&lang=js"
import style0 from "./CatastropheClosings.vue?vue&type=style&index=0&id=ec5f28ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5f28ec",
  null
  
)

export default component.exports